import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    Step1 as WhitepaperTemplate,
    secondStep,
    successTemplate,
} from "./whitepaper.templates";

export default {
    title: "Website/Partial Templates/Whitepaper",
    render: WhitepaperTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Step1 = {
    args: {
        oneColumn: true,
        oneDownload: false,
    },
};

export const Step2 = {
    render: secondStep.bind({}),
};

export const Success = {
    render: successTemplate.bind({}),
};
